//  Accordion List

/* eslint-disable */
$(function () {
  $('.accordion__title').on('click', function () {
    $(this).parent().siblings('.accordion').removeClass('is-open').find('.accordion__panel').slideUp('fast');
    $(this).parent().toggleClass('is-open').find('.accordion__panel').first().slideToggle('fast');
  });
});
/* eslint-enable */
